/**
 * RFC 4180–style escaping; safe for commas, quotes, newlines.
 *
 * @param {string} field
 * @returns {string}
 */
export function escapeCsvField(field) {
  const s = field == null ? '' : String(field);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/**
 * @param {string[][]} matrix
 * @returns {string}
 */
export function stringMatrixToCsvString(matrix) {
  if (!matrix.length) {
    return '';
  }
  return matrix.map((row) => row.map((cell) => escapeCsvField(cell)).join(',')).join('\r\n');
}

/**
 * UTF-8 BOM helps Excel open CSV with correct encoding.
 *
 * @param {string[][]} matrix
 * @returns {Blob}
 */
export function buildCsvBlob(matrix) {
  const body = stringMatrixToCsvString(matrix);
  const bom = '\uFEFF';
  return new Blob([bom + body], { type: 'text/csv;charset=utf-8;' });
}
